import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import ErrorToast from './ErrorToast';
import { errorRemove, deleteLedmodule } from '../../actions';
import LedmoduleNotFound from './LedmoduleNotFound';

class ErrorsContainer extends React.Component {
    constructor() {
        super();

        this.onClose = this.onClose.bind(this);
    }

    onClose(error) {
        this.props.errorRemove(error);
    }

    renderErrors() {
        if (this.props.notFound !== null) {
            return (<LedmoduleNotFound />);
        }

        // if (this.props.notDriverLedmodules !== null) {
        //     return (<LedmoduleWithoutDriver />);
        // }

        let errorsList = this.props.errors.map((error, key) => {
            if (error.ledmoduleId) {
                //ledmodule to remove since this condition means that it was an error adding the driver, but the ledmodule was created anyway
                this.props.deleteLedmodule(error.ledmoduleId)
                    .then(() => {
                        error.ledmoduleId = null;
                    })
                    .catch(error => {
                        console.error("ERROR DELETING LEDMODULE ---> ", error);
                    });
            }
            return (
                <ErrorToast
                    key={key}
                    error={error}
                    onClose={this.onClose} />
            )
        });

        return (
            <div style={{ minHeight: '6rem' }} >
                <div style={{ position: 'absolute', right: '1rem' }} >
                    {errorsList}
                </div>
            </div>
        );

        // return this.props.errors.map((error, key) => {
        //     return (
        //         <ErrorToast
        //             key={key}
        //             error={error}
        //             onClose={this.onClose} />
        //     )
        // });
    }

    render() {
        return (
            <div>
                {this.renderErrors()}
            </div>
        )
    }
};

const mapStateToProps = (state) => {
    return {
        errors: state.errorsHandler.errors,
        notFound: state.errorsHandler.notFound,
        notDriverLedmodules: state.errorsHandler.notDriverLedmodules
    };
};

const mapDispatchToProps = {
    errorRemove,
    deleteLedmodule
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(ErrorsContainer));
